<template>
	<DefaultTemplate>
		<signIn/>
	</DefaultTemplate>
</template>

<script>
	import  DefaultTemplate from '../template/DefaultTemplate'
	import  signIn from '../components/SignInAuth'
	export default{
		name:'test',
		methods:{
		},
		components:{
			DefaultTemplate,
			signIn
		},
	}
</script>